export default {
  checkout: () => import("/builds/robustastudio/mazaya/pancho-v3/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/builds/robustastudio/mazaya/pancho-v3/layouts/default.vue").then(m => m.default || m),
  minimal: () => import("/builds/robustastudio/mazaya/pancho-v3/layouts/minimal.vue").then(m => m.default || m)
}